import _ from "lodash";
import moment from "moment";
import api from "@/service/cartManage.js";

const state = {
  default: {
    baseDiscountList: {
      baseDiscount: {
        discountRepeat: "notRepeat",

        wholeBuilding: {
          use: false,
          code: "",
          value: "",
        },

        payFull: {
          limit: "",
          model: "percentage",
          remark: "",
          discountList: [{
            limit: "",
            value: ""
          }, {
            limit: "",
            value: ""
          }, {
            limit: "",
            value: ""
          }, {
            limit: "",
            value: ""
          }, {
            limit: "",
            value: ""
          }]
        }
      },

      memberLevelList: [],
      discountCodeList: [],
    },
    discountData: {
      name: "",
      frontWebShow: false,
      frontWebContent: "",
      time: {
        startTime: new Date(moment()),
        endTime: new Date(moment().add("month", 1)),
      },

      useModel: "inTime",
      limitModel: "payFull",
      limitType: "grandTotal",
      totalThenDiscount: false,
      anyThenDiscount: false,
      payFullLimit: "buyCount",
      payFullModel: "realNumber",
      payFullDiscount: [{
        limit: "",
        value: ""
      }, {
        limit: "",
        value: ""
      }, {
        limit: "",
        value: ""
      }],
      payFullUse: false,
      payFullCode: ""
    },
  },

  cartDiscountList: [],
  baseDiscount: {
    discountRepeat: "notRepeat",

    wholeBuilding: {
      use: false,
      code: "",
      value: "",
    },

    payFull: {
      limit: "",
      model: "percentage",
      remark: "",
      discountList: [{
        limit: "",
        value: ""
      }, {
        limit: "",
        value: ""
      }, {
        limit: "",
        value: ""
      }, {
        limit: "",
        value: ""
      }, {
        limit: "",
        value: ""
      }]
    }
  },
  memberLevelList: [],
  discountCodeList: [],
  cartDiscoundData: {
    name: "",
    frontWebShow: false,
    frontWebContent: "",
    time: {
      startTime: new Date(moment()),
      endTime: new Date(moment().add("month", 1)),
    },

    useModel: "inTime",
    limitModel: "payFull",
    limitType: "grandTotal",
    totalThenDiscount: false,
    anyThenDiscount: false,
    payFullLimit: "buyCount",
    payFullModel: "realNumber",
    payFullDiscount: [{
      limit: "",
      value: ""
    }, {
      limit: "",
      value: ""
    }, {
      limit: "",
      value: ""
    }],
    payFullUse: false,
    payFullCode: ""
  },
};
const getters = {}
const actions = {
  autoDiscountCode() {
    const codeLength = Math.round(Math.random() * 5) + 6;
    const eleArr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e',
      'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
      'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
      'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
    ];

    let code = "";

    for (let i = 1; i < codeLength; i++) {
      const temp = Math.round(Math.random() * (eleArr.length - 1));
      code += eleArr[temp];
    }

    return code;
  },

  cartDiscountSave({
    state,
    commit
  }, data) {
    let result = api.cartDiscountSave(data);
    result.then((data) => {
      console.log(data);
    });
    return result;
  },

  getCartDiscount({
    state,
    commit
  }, uid) {
    if (uid == "insert") {
      let discountData = JSON.parse(JSON.stringify(state.default.discountData));
      commit("setDiscountData", discountData);
      return "insert";
    }

    let result = api.getCartDiscount(uid);
    result.then((data) => {
      if (data.data.state) {
        let discountData = _.mapValues(data.data.result, (item, key) => {
          if (key == "time") {
            item.startTime = new Date(item.startTime);
            item.endTime = new Date(item.endTime);
          }
          return item;
        });
        commit("setDiscountData", data.data.result);
      }
    });
    return result;
  },

  getCartDiscountList({
    state,
    commit
  }) {
    let result = api.getCartDiscountList();
    result.then((data) => {
      if (data.data.state) {
        commit("setCartDiscountList", data.data.result);
      } else {

      }
    });
    return result;
  },

  getBaseDiscount({
    state,
    commit
  }) {
    let result = api.getBaseDiscount();
    result.then((data) => {
      if (data.data.state) {
        commit("setBaseDiscount", data.data.result);
      } else {
        let temp = JSON.stringify(JSON.parse(state.default.baseDiscountList));
        commit("setBaseDiscount", temp);
      }
    });
    return result;
  },

  baseDiscountSave({
    state,
    commit
  }, data) {
    let result = api.baseDiscountSave(data);
    result.then((data) => {
      console.log(data);
    });
    return result;
  },

  discountCodeSave({
    state,
    commit
  }, data) {
    let result = api.discountCodeSave(data);
    result.then((data) => {
      if (data.data.state) {
        commit("setDiscountCodeList", data.data.result);
      }
    });
    return result;
  },
};
const mutations = {
  setBaseDiscount(state, data) {
    state.baseDiscount = data.baseDiscount;
    state.memberLevelList = data.memberLevelList;
    state.discountCodeList = data.discountCodeList;
  },

  setDiscountCodeList(state, data) {
    state.discountCodeList = data;
  },

  setCartDiscountList(state, data) {
    state.cartDiscountList = data;
  },

  setDiscountData(state, data) {
    state.cartDiscoundData = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
